if (!customElements.get('swym-wishlist-page')) {
  class SwymWishlistPage extends HTMLElement {
    constructor() {
      super()
      this._initializeSwymComponent()
    }

    _init(swat) {
      this._initializeSelectors(swat)
      this.setupData()
      this.isShareWishlistPage
        ? this._renderShareWishlist(swat)
        : this._renderWishlist(swat)
      this._attachEventListeners()
    }

    /* General funcions */

    _initializeSwymComponent() {
      if (!window.SwymCallbacks) window.SwymCallbacks = []
      window.SwymCallbacks.push(this._init.bind(this))
    }

    setupData() {
      this.data = {
        searchUrl: window.wishListRouteSearchUrl,
        message: {
          emptyItem: this.getAttribute('messageEmptyItem') || 'No items',
          error: this.getAttribute('messageError') || "Can't get data",
        },
      }
    }

    async renderProductHTML(list, type) {
      try {
        let variantIds = list.map((item) => {
          return item.epi
        })

        const lid = list.find((item) => item.lid).lid

        let productIds = list.map((item) => {
          return `(id:"${item.empi}")`
        })
        let queryString = Array.from(new Set(productIds)).join(' OR ')

        let isSizeSelectedMapping = list.map((item) => {
          return item.cprops && item.cprops.isSizeSelected === true
            ? 'true'
            : 'false'
        })

        const searchString = `&variant_ids=${variantIds.join('-')}&lid=${lid}&list_type=${type}&is_share_wishlist_page=${this.isShareWishlistPage}&is_size_selected_mapping=${isSizeSelectedMapping.join('-')}&type=product&q=${queryString}`

        if (list.length > 0) {
          return await fetch(this.data.searchUrl + searchString, {
            credentials: 'same-origin',
            method: 'GET',
          })
            .then((response) => response.json())
            .then((data) => {
              if (data.items && data.items.length) {
                let html = ''
                let itemData = data.items.filter((item) => item)

                list.forEach((item) => {
                  let productCard = itemData.find(
                    (productItem) => productItem.id === item.epi
                  )
                  if (productCard) {
                    html += productCard.html
                  }
                })

                return {
                  listHtml: html,
                  total: data.total,
                }
              } else {
                this.renderEmpty()
              }
            })
        } else {
          this.renderEmpty()
        }
      } catch (e) {
        console.log(e)
        this.renderError()
      }
    }

    _initializeSelectors(swat) {
      this.lists = []
      this.swat = swat
      this.body = document.body
      this.settings = JSON.parse(this.dataset.settings)
      this.isShareWishlistPage = window.isShareListPage
      this.isSingleList = !swat.retailerSettings.Wishlist.EnableCollections
      this.isShareEnabledUsingSocialMedia =
        swat.retailerSettings.Wishlist?.AllowSharing || false
      this.isSFLEnabled = swat.retailerSettings.SFL?.SFLFeatureEnabled || false

      /* Page Header Selectors */

      this.accountButton = this.querySelector('#swymcs-user-login-status-btn')
      this.accountPopup = this.querySelector('#swymcs-user-login-status-popup')
      this.accountPopupCloseButton = this.querySelector(
        '#swymcs-close-account-popup'
      )
      this.accountPopupCancelButton = this.querySelector(
        '#swymcs-cancel-account-popup'
      )
      this.accountPopupActionButton = this.querySelector(
        '#swymcs-account-login-action-button'
      )
      this.listSenderName = this.querySelector(
        '#swymcs-lists-share-sender-details-name-value'
      )
      this.listSenderEmail = this.querySelector(
        '#swymcs-lists-share-sender-details-email-value'
      )
      this.listSenderTier = this.querySelector(
        '#swymcs-lists-share-sender-details-tier-value'
      )
      this.pageTitleTabContainer = this.querySelector('#swymcs-title-wrapper')
      this.pageTitleWishlistTab = this.querySelector('#swymcs-page-title')
      this.pageTitleSFLTab = this.querySelector('#swymcs-sfl-page-title')

      /* Wishlist grid container */
      this.emptyListContainer = this.querySelector(
        '#swym-empty-wishlist-container'
      )
      this.emptySFLListContainer = this.querySelector(
        '#swym-empty-sfl-list-container'
      )
      this.wishlistContainer = this.querySelector('#swymcs-wishlist-container')
      this.listsContainer = this.querySelector('#swymcs-lists-grid')
      this.listProductsContainer = this.querySelector(
        '#swymcs-products-grid-container'
      )
      this.productsContainer = this.querySelector('#swymcs-products-grid')
      this.sflProductsContainer = this.querySelector(
        '#swymcs-sfl-products-grid'
      )
      this.wishlistHeader = this.querySelector('#swymcs-wishlist-header')
      this.backToListView = this.querySelector('#swymcs-back-to-lists-view')
      this.pageLoader = this.querySelector('#swymcs-loader-container')

      this.currentGridType = 'wishlist'

      /* Lists header selectors */
      this.activeListContainer = this.querySelector('#swymcs-active-list')
      this.activeListImage = this.querySelector('#swymcs-active-list-image')
      this.activeListImageText = this.querySelector(
        '#swymcs-active-list-image-text'
      )
      this.activeListTilte = this.querySelector('#swymcs-active-list-title')
      this.activeListItemCount = this.querySelector(
        '#swymcs-active-list-item-count'
      )
      this.headerListsContainer = this.querySelector('#swymcs-header-lists')

      /* Additional Options selectors */

      this.additionalOptionsContainer = this.querySelector(
        '#swymcs-additional-options'
      )
      this.additionalOptionsBtn = this.querySelector(
        '#swymcs-view-additional-options'
      )
      this.shareListButton = this.querySelector('#swymcs-share-list')
      this.renameListButton = this.querySelector('#swymcs-rename-list')
      this.duplicateListButton = this.querySelector('#swymcs-duplicate-list')
      this.deleteListButton = this.querySelector('#swymcs-delete-list')

      /* Additional Options popup selectors */
      this.additionalOptionsPopupContainer = this.querySelector(
        '#swymcs-additional-options-popup-container'
      )
      this.additionalOptionsPopupCloseButton = this.querySelector(
        '#swymcs-close-additional-popup'
      )
      this.additionalPopupCancelButtons = this.querySelectorAll(
        '.swymcs-additonal-popup-cancel-button'
      )

      /* Share List popup selectors */
      this.shareListPopup = this.querySelector('#swymcs-share-list-popup')
      this.shareLinkField = this.querySelector('#swymcs-share-link-field')
      this.shareNameField = this.querySelector('#swymcs-share-name-field')
      this.shareEmailField = this.querySelector('#swymcs-share-email-field')
      this.shareMessageField = this.querySelector('#swymcs-share-message-field')
      this.shareListError = this.querySelector(
        '#swymcs-share-email-field-error'
      )
      this.emailShareButton = this.querySelector('#swymcs-confirm-share-list')
      this.additionalShareButtonsContainer = this.querySelector(
        '.swymcs-additional-share-buttons-container'
      )
      this.copyLinkButton = this.querySelector(
        '#swymcs-confirm-share-list--copy'
      )
      this.facebookShareButton = this.querySelector(
        '#swymcs-confirm-share-list--facebook'
      )
      this.twitterShareButton = this.querySelector(
        '#swymcs-confirm-share-list--twitter'
      )

      /* Delete List popup selectors */
      this.deleteListPopup = this.querySelector('#swymcs-delete-list-popup')
      this.deleteListName = this.querySelector(
        '#swymcs-confirm-delete-list-name'
      )
      this.confirmDeleteListButton = this.querySelector(
        '#swymcs-confirm-delete-list'
      )

      /* Rename List popup selectors */
      this.renameListPopup = this.querySelector('#swymcs-rename-list-popup')
      this.renameListName = this.querySelector(
        '#swymcs-confirm-rename-list-name'
      )
      this.renameListError = this.querySelector('#swymcs-rename-list-error')
      this.renameListTextField = this.querySelector('#swymcs-rename-list-field')
      this.confirmRenameListButton = this.querySelector(
        '#swymcs-confirm-rename-list'
      )

      /* Duplicate List popup selectors */
      this.duplicateListPopup = this.querySelector(
        '#swymcs-duplicate-list-popup'
      )
      this.duplicateListName = this.querySelector(
        '#swymcs-confirm-duplicate-list-name'
      )
      this.duplicateListError = this.querySelector(
        '#swymcs-duplicate-list-error'
      )
      this.duplicateListTextField = this.querySelector(
        '#swymcs-duplicate-list-field'
      )
      this.confirmDuplicateListButton = this.querySelector(
        '#swymcs-confirm-duplicate-list'
      )

      /* Variant Selection popup selectors */
      this.variantSelectionPopup = this.querySelector(
        '#swymcs-variant-selection-popup'
      )
      this.variantSelectionPopupBody = this.querySelector(
        '#swymcs-variant-selection-popup-body'
      )
      this.variantSelectionPopupCloseButton = this.querySelector(
        '#swymcs-close-variant-selection-popup'
      )
      this.variantSelectionPopupTitle = this.querySelector(
        '#swymcs-variant-selection-popup-title'
      )
      this.variantSelectionPopupContentBody = this.querySelector(
        '#swymcs-variant-selection-popup-content-body'
      )
    }

    _attachEventListeners() {
      this.body.addEventListener('click', (evt) => this._overlayEvent(evt))

      /* Adding events to page header elements */

      this.accountButton.addEventListener('click', () =>
        this._showPopupContainer(this.accountPopup)
      )
      this.accountPopupCloseButton.addEventListener('click', () =>
        this._hidePopupContainer(this.accountPopup)
      )
      this.accountPopupCancelButton.addEventListener('click', () =>
        this._hidePopupContainer(this.accountPopup)
      )
      this.accountPopupActionButton.addEventListener(
        'click',
        this._loginButtonAction.bind(this)
      )
      this.pageTitleTabContainer.addEventListener(
        'click',
        this._toggleListView.bind(this)
      )

      /* Header Lists Events */

      this.activeListContainer.addEventListener('click', () =>
        this._showPopupContainer(this.headerListsContainer)
      )
      this.headerListsContainer.addEventListener(
        'click',
        this._switchListsFromHeader
      )

      /* Additional Options Events */
      this.additionalOptionsBtn.addEventListener('click', () =>
        this._showPopupContainer(this.additionalOptionsContainer)
      )
      this.additionalOptionsContainer.addEventListener(
        'click',
        this._renderAdditionalOptionsPopup
      )
      this.shareListButton.addEventListener(
        'click',
        this._renderShareListPopup.bind(this)
      )

      /* Additional Options Popup Events */
      this.additionalPopupCancelButtons.forEach((btn) =>
        btn.addEventListener(
          'click',
          this._closeAdditionalOptionsPopup.bind(this)
        )
      )
      this.additionalOptionsPopupCloseButton.addEventListener(
        'click',
        this._closeAdditionalOptionsPopup.bind(this)
      )

      /* Share List Events */
      this.copyLinkButton.addEventListener(
        'click',
        this._shareListByCopy.bind(this)
      )
      this.emailShareButton.addEventListener(
        'click',
        this._shareListByEmail.bind(this)
      )
      this.facebookShareButton.addEventListener('click', () =>
        this._shareListOnPlatform('facebook')
      )
      this.twitterShareButton.addEventListener('click', () =>
        this._shareListOnPlatform('twitter')
      )
      this.shareEmailField.addEventListener(
        'input',
        this._validateEmail.bind(this)
      )

      /* Rename List Events */
      this.confirmRenameListButton.addEventListener(
        'click',
        this._renameList.bind(this)
      )
      this.renameListTextField.addEventListener('input', () =>
        this._validateListName(
          this.renameListTextField.value.trim().toLowerCase(),
          this.renameListError
        )
      )

      /* Duplicate List Events */
      this.confirmDuplicateListButton.addEventListener(
        'click',
        this._duplicateList.bind(this)
      )
      this.duplicateListTextField.addEventListener('input', () =>
        this._validateListName(
          this.duplicateListTextField.value.trim().toLowerCase(),
          this.duplicateListError
        )
      )

      /* Delete List Events */
      this.confirmDeleteListButton.addEventListener(
        'click',
        this._deleteList.bind(this)
      )

      /* Lists grid buttons */
      this.listsContainer.addEventListener('click', this._showListDetails)
      this.productsContainer.addEventListener(
        'click',
        this._eventsForProductsGrid
      )
      this.sflProductsContainer.addEventListener(
        'click',
        this._eventsForProductsGrid
      )
      this.backToListView.addEventListener(
        'click',
        this._triggerBackToListView.bind(this)
      )

      /* Variant Selection Popup Events */
      this.variantSelectionPopup.addEventListener(
        'click',
        this._eventsForVariantSelectionModal.bind(this)
      )
      this.variantSelectionPopupCloseButton.addEventListener('click', () => {
        this.variantSelectionPopup.close()
      })
    }

    async _triggerBackToListView() {
      this._renderMultipleList()
    }

    _showListDetails(evt) {
      const target = evt.target
      const page = document.querySelector('swym-wishlist-page')
      if (target.getAttribute('id') != 'swymcs-lists-grid') {
        const lid = evt.target.closest('.swymcs-list-item').dataset.lid
        const action = target?.dataset?.action || 'view-list'
        if (
          target.classList.contains('swymcs-view-list-button') &&
          action == 'shop'
        )
          location.href = '/'
        else page._renderListProducts(lid)
      }
      return
    }

    async _renderWishlist() {
      this.lists = await this._getCompleteListDetails()
      this.lists.length
        ? this.isSingleList
          ? this._renderSingleList()
          : this._renderMultipleList()
        : this._renderEmptyState()
      this._renderSFLContents()
    }

    async _renderShareWishlist() {
      const lid = new URL(document.location).searchParams.get('lid')

      // Common UI updates
      const updateUI = (showHeader = true) => {
        this._showContainer(this.listProductsContainer)
        this._showContainer(this.wishlistContainer)
        this._hideContainer(this.pageLoader)
        this._hideContainer(this.backToListView)
        if (!showHeader) {
          this._hideContainer(this.wishlistHeader)
        }
      }

      if (!lid) {
        this._renderProductsGrid([])
        updateUI(false)
        return
      }

      window.currentActiveListId = lid
      try {
        const wishlistProducts = await this._getProductsFromList(lid)
        this.listcontents = await this._getShopifyProductsData(wishlistProducts)
        if (!this.listcontents || !this.listcontents.length) {
          this._renderEmptyList()
          updateUI(false)
          return
        }

        await this._renderSharedListHeader(lid)
        this._renderProductsGrid(this.listcontents)
        if (window.isLoggedIn && window.isStoreOwner) this._showCopyLinkInput()
        updateUI()
      } catch (error) {
        console.error('Error fetching wishlist products:', error)
        this._renderEmptyList()
        updateUI(false)
      }
    }

    async _renderSingleList(shouldRefreshState = true) {
      if (!shouldRefreshState) {
        this._hideContainer(this.pageLoader)
        this._showContainer(this.wishlistHeader)
        const hasListData = this.list && this.list.listcontents != []
        if (!hasListData) {
          this._renderProductsGrid(this.list.listcontents)
        } else {
          this._switchGrid('wishlist')
        }
        this._showContainer(this.wishlistContainer)
        this._showContainer(this.listProductsContainer)
        return
      }

      this.lists = await this._getLists()
      if (!this.lists.length) {
        this._renderEmptyState()
        return
      }
      this.list =
        this.lists.find((list) => list.lname.toLowerCase() == 'my wishlist') ||
        this.lists[0]
      window.currentActiveListId = this.list.lid
      this.list.listcontents = await this._getProductsFromList(this.list.lid)
      this.list.listcontents = await this._getShopifyProductsData(
        this.list.listcontents
      )

      // Cache the list data
      this.list = this._setListProperties(
        this.list,
        this.list.listcontents,
        true
      )

      this._hideContainer(this.pageLoader)
      await this._renderSingleListHeader(this.list.lid)
      this._renderProductsGrid(this.list.listcontents)
      this._hideContainer(this.sflProductsContainer)
      this._switchGrid('wishlist')
      this._showContainer(this.wishlistContainer)
      this._showContainer(this.listProductsContainer)

      this.swat.initializeActionButtons('form#cart')
    }

    _renderMultipleList() {
      if (!this.lists.length) {
        this._renderEmptyState()
        return
      }
      this._renderListsView()
      this.emptyListContainer.classList.add('swym-hide-container')
      this.wishlistContainer.classList.remove('swym-hide-container')
    }

    _renderEmptyState() {
      this._hideContainer(this.pageLoader)
      this.emptyListContainer.classList.remove('swym-hide-container')
      this.wishlistContainer.classList.add('swym-hide-container')
    }

    async _renderListsView() {
      window.currentActiveListId = ''
      const html = this.lists
        .map((list) => {
          const productCount = list.totalProducts || 0
          const buttonText = !productCount ? 'Continue Shopping' : 'View List'
          const buttonAction = !productCount ? 'shop' : 'view-list'

          const imageHtml = this._generateListPreviewImages(list)

          return `
                  <button class="swymcs-button swymcs-list-item swymcs-wishlist-grid-item" 
                          data-lid="${list.lid}" 
                          aria-label="View list ${list.lname}" 
                          id="list--${list.lid}">
                      <div class="swymcs-list-title-container">
                          <div class="swymcs-list-title">${list.lname}</div>
                      </div>
                      <div class="swymcs-list-product-count-container">
                          <span class="swymcs-product-count">${productCount}</span>
                          <span class="swymcs-product-count-text">${productCount > 1 ? 'products' : 'product'}</span>
                      </div>
                      ${imageHtml}
                      <div class="swymcs-view-list-button" 
                           data-action="${buttonAction}" 
                           id="swymcs-view-list-button-${list.lid}" 
                           aria-label="${buttonText}">
                          ${buttonText}
                      </div>
                  </button>
              `
        })
        .join('')

      this.listsContainer.innerHTML = html
      this._showContainer(this.listsContainer)
      this._hideContainer(this.listProductsContainer)
      this._hideContainer(this.pageLoader)
    }

    _generateListPreviewImages(list) {
      const listContents = list?.listcontents || []
      let imageHtml = `<div class="swymcs-list-image-container">`

      if (listContents.length) {
        for (let i = 0; i < 3; i++) {
          if (listContents[i]) {
            const product = listContents[i].productData
            const selectedVariant = product.variants.find(
              (variant) => variant.id === listContents[i].epi
            )
            const imageSrc =
              selectedVariant?.featured_image?.src ||
              product?.featured_image ||
              listContents[i].iu
            imageHtml += `
                          <div class="swymcs-wishlist-image-wrapper">
                              <img src="${imageSrc}" 
                                   alt="${listContents[i].productData.title}" 
                                   class="swymcs-wishlist-image"/>
                          </div>`
          }
        }
        imageHtml += '</div>'
      } else {
        imageHtml += `<p class="swymcs-no-products-message">This is an empty list!</p></div>`
      }

      return imageHtml
    }

    async _renderListProducts(lid) {
      this._hideContainer(this.listsContainer)
      this._showContainer(this.pageLoader)
      this._showContainer(this.wishlistHeader)
      this._showContainer(this.backToListView)
      this._showContainer(this.activeListContainer)
      window.currentActiveListId = lid

      const selectedList = this.lists.find((list) => list.lid == lid)
      if (!selectedList.allProductsLoaded) {
        const allProducts = await this._getProductsFromList(lid)
        selectedList.listcontents =
          await this._getShopifyProductsData(allProducts)
        selectedList.allProductsLoaded = true
      }

      this._renderListHeader(lid)
      this._hideContainer(this.pageLoader)
      this._renderProductsGrid(selectedList.listcontents)
      this._switchGrid('wishlist')
      this._showContainer(this.listProductsContainer)
    }

    async _renderSharedListHeader(lid) {
      const mainPageHeader = this.querySelector(
        '#swymcs-page-header-main-title>h1'
      )
      const { list: activeList } = await this._getListDetails(lid)
      mainPageHeader.textContent = `${activeList.cby} shared their Wishlist`
      activeList.listcontents = this.listcontents
      this._renderActiveList(activeList)
      this.activeListContainer.style.pointerEvents = 'none'
      this._hideContainer(this.additionalOptionsBtn)
      this._hideContainer(this.shareListButton)
      this._hideContainer(this.pageTitleTabContainer)
    }

    async _renderSingleListHeader() {
      this._renderActiveList(this.list)
      this.activeListContainer.style.pointerEvents = 'none'
      this._showContainer(this.additionalOptionsBtn)
      this._hideContainer(this.backToListView)
      this._hideContainer(this.pageLoader)
      this._hideContainer(this.renameListButton)
      this._hideContainer(this.duplicateListButton)
    }

    async _renderListHeader(lid) {
      const lists = this.lists
      const activeList = lists.find((list) => list.lid == lid)
      this._renderActiveList(activeList)
      let html = ``
      lists.forEach((list) => {
        const listContents = list?.listcontents || []
        if (listContents.length) {
          const product = listContents[0].productData
          const selectedVariant = product.variants.find(
            (variant) => variant.id === listContents[0].epi
          )
          const imageSrc =
            selectedVariant?.featured_image?.src ||
            product?.featured_image ||
            listContents[0].iu
          html += `
                  <li class="swymcs-header-list-item" data-lid="${list.lid}">
                      <img src="${imageSrc}" alt="${list.lname}"/>
                      <span class="swym-list-item">${list.lname} (${listContents.length})</span>
                  </li>`
        } else {
          html += `
                  <li class="swymcs-header-list-item" data-lid="${list.lid}">
                      <span class="swymcs-list-item-image-text">${list.lname[0]}</span>
                      <span class="swymcs-list-item">${list.lname} (0)</span>
                  </li>`
        }
      })
      this.headerListsContainer.innerHTML = html
    }

    _renderActiveList(list) {
      const listContent = list?.listcontents || []
      this.activeListTilte.textContent = list.lname
      this.activeListItemCount.textContent =
        `${listContent.length}` + (listContent.length == 1 ? ' Item' : ' Items')
    }

    renderError() {
      console.error(this.data.message.error)
      this._renderEmptyState()
      return
    }

    _renderProductsGrid(shopifyProducts, type = 'wishlist') {
      const targetContainer =
        type == 'sfl' ? this.sflProductsContainer : this.productsContainer
      if (!shopifyProducts.length) {
        if (type == 'sfl') {
          this._renderEmptySFLList(targetContainer)
        } else {
          this._renderEmptyList(targetContainer)
        }
        return
      }
      this.renderProductHTML(shopifyProducts, type)
        .then((data) => {
          if (!data || !data.listHtml) {
            console.log('Nothing returned from renderProductHTML')
            return
          }
          const tempDiv = document.createElement('div')
          tempDiv.innerHTML = data.listHtml

          const itemSelector = '.swymcs-product-card'
          const items = Array.from(tempDiv.querySelectorAll(itemSelector))

          items.sort((a, b) => {
            const titleA = (a.getAttribute('data-title') || '').toLowerCase()
            const titleB = (b.getAttribute('data-title') || '').toLowerCase()
            if (titleA < titleB) return -1
            if (titleA > titleB) return 1
            return 0
          })

          tempDiv.innerHTML = ''
          items.forEach((item) => tempDiv.appendChild(item))

          data.listHtml = tempDiv.innerHTML
          targetContainer.innerHTML = data.listHtml
          targetContainer.classList.remove('swymcs-empty-list')
          this._updateAddToCartButtonText()
        })
        .catch((error) => {
          console.error(error)
          this.renderError()
        })
    }

    _updateAddToCartButtonText() {
      const addToCartButtons = document.querySelectorAll(
        '.swymcs-add-to-cart-btn[data-purpose="cart"]'
      )
      addToCartButtons.forEach((button) => {
        const variantId = +button.dataset.epi
        const isInCart = window._swat.platform.isInDeviceCart(variantId)
        if (isInCart) {
          button.textContent = this.settings.added_to_cart_text
          button.classList.add('swymcs-product-in-cart')
        }
      })
    }

    _renderEmptySFLList(container = this.sflProductsContainer) {
      container.classList.add('swymcs-empty-list')
      container.innerHTML = window.emptySFLListContent
      const emptyContainer = container.querySelector(
        '#swym-empty-sfl-list-container'
      )
      if (emptyContainer) {
        emptyContainer.classList.remove('swym-hide-container')
      }
    }

    _renderEmptyList(container = this.productsContainer) {
      container.classList.add('swymcs-empty-list')
      container.innerHTML = window.emptyListContent
      const emptyContainer = container.querySelector(
        '#swym-empty-wishlist-container'
      )
      if (emptyContainer) {
        emptyContainer.classList.remove('swym-hide-container')
      }
    }

    _switchGrid(type) {
      if (type === 'wishlist') {
        this._showContainer(this.productsContainer)
        this._hideContainer(this.sflProductsContainer)
        this.currentGridType = 'wishlist'
        this._showContainer(this.wishlistHeader)
        if (this.isSingleList && this.list) {
          this._renderActiveList(this.list)
        } else if (window.currentActiveListId) {
          const activeList = this.lists.find(
            (list) => list.lid === window.currentActiveListId
          )
          if (activeList) {
            this._renderActiveList(activeList)
          }
        }
      } else if (type === 'sfl') {
        this._hideContainer(this.productsContainer)
        this._showContainer(this.sflProductsContainer)
        this.currentGridType = 'sfl'
        this._showContainer(this.wishlistHeader)
        this._renderSFLHeader()
      }
    }

    _renderSFLHeader() {
      if (this.sflList && this.sflList.listcontents) {
        const sflListContent = this.sflList.listcontents || []
        this.activeListTilte.textContent =
          this.sflList.lname || 'Save For Later'
        this.activeListItemCount.textContent =
          `${sflListContent.length}` +
          (sflListContent.length == 1 ? ' Item' : ' Items')
      }
    }

    async _renderShareListPopup() {
      this._closeAdditionalOptionsPopup()
      this._renderShareList()
    }

    async _renderAdditionalOptionsPopup(evt) {
      const page = document.querySelector('swym-wishlist-page')
      const target = evt.target
      if (target.id == 'swymcs-additional-options') return
      page._hidePopupContainer(page.querySelector('.swym-active-popup'))
      const action = target.dataset.action
      page._closeAdditionalOptionsPopup()
      if (action == 'share') page._renderShareList()
      else if (action == 'rename') page._renderRenameList()
      else if (action == 'duplicate') page._renderDuplicateList()
      else if (action == 'delete') page._renderDeleteList()
    }

    _closeAdditionalOptionsPopup() {
      this._hideContainer(this.shareListPopup)
      this._hideContainer(this.renameListPopup)
      this._hideContainer(this.duplicateListPopup)
      this._hideContainer(this.deleteListPopup)
      this._hidePopupContainer(this.additionalOptionsPopupContainer)
    }

    async _renderShareList() {
      if (!window.isLoggedIn) {
        this._hidePopupContainer(this.additionalOptionsContainer)
        this._showPopupContainer(this.accountPopup)
        return
      }

      let listId
      if (this.currentGridType == 'sfl') {
        listId = this.sflList.listid
      } else {
        listId = window.currentActiveListId
      }
      const shareableLink = await this._prepareShareLink(listId)
      this.shareLinkField.textContent = shareableLink

      !this.isShareEnabledUsingSocialMedia &&
        this._hideContainer(this.additionalShareButtonsContainer)
      this._showContainer(this.shareListPopup)
      this._showPopupContainer(this.additionalOptionsPopupContainer)
      await this._markListAsPublic(listId)
    }

    _markListAsPublic(listId) {
      return new Promise((resolve, reject) => {
        this.swat.markListPublic(
          listId,
          (list) => resolve(list),
          (err) => reject(err)
        )
      })
    }

    _renderRenameList() {
      this.renameListName.textContent = this.activeListTilte.textContent
      this.renameListTextField.value = this.activeListTilte.textContent
      this.renameListTextField.placeholder = this.activeListTilte.textContent
      this._showContainer(this.renameListPopup)
      this._showPopupContainer(this.additionalOptionsPopupContainer)
    }

    _renderDuplicateList() {
      this.duplicateListName.textContent = this.activeListTilte.textContent
      this.duplicateListTextField.value =
        'Copy Of ' + this.activeListTilte.textContent
      this.duplicateListTextField.placeholder = this.activeListTilte.textContent
      this._showContainer(this.duplicateListPopup)
      this._showPopupContainer(this.additionalOptionsPopupContainer)
    }

    _renderDeleteList() {
      this.deleteListName.textContent = this.activeListTilte.textContent
      this._showContainer(this.deleteListPopup)
      this._showPopupContainer(this.additionalOptionsPopupContainer)
    }

    /* Show / Hide containers */

    _overlayEvent(evt) {
      if (evt.target.nodeName == 'BODY') {
        this.querySelectorAll('.swym-active-popup').forEach((popup) =>
          this._hidePopupContainer(popup)
        )
      }
    }

    _showPopupContainer(selector) {
      selector.classList.remove('swym-hide-container')
      selector.classList.add('swym-active-popup')
      this.body.classList.add('no-scroll')
    }

    _hidePopupContainer(selector) {
      selector.classList.add('swym-hide-container')
      selector.classList.remove('swym-active-popup')
      this.body.classList.remove('no-scroll')
    }

    _showContainer(selector) {
      selector.classList.remove('swym-hide-container')
    }

    _hideContainer(selector) {
      selector.classList.add('swym-hide-container')
    }

    /* Javascript APIs related functions */
    _getLists() {
      return new Promise((resolve, reject) => {
        this.swat.fetchLists({
          callbackFn: (lists) => resolve(lists),
          errorFn: (err) => reject(err),
        })
      })
    }

    _getListDetails(lid) {
      return new Promise((resolve, reject) => {
        this.swat.fetchListDetails(
          { lid: lid },
          (list) => resolve(list),
          (error) => reject(error)
        )
      })
    }

    async _getCompleteListDetails() {
      const lists = await this._getLists()
      if (!lists.length) return lists

      await Promise.all(
        lists.map(async (list) => {
          const products = await this._getProductsFromList(list.lid)
          list.listcontents = products.slice(0, 3)
          list.listcontents = await this._getShopifyProductsData(
            list.listcontents
          )
          if (products.length <= 3) list.allProductsLoaded = true
          list.totalProducts = products.length
        })
      )
      return lists
    }

    _getProductsFromList(lid) {
      return new Promise((resolve, reject) => {
        this.swat.fetchListCtx(
          { lid: lid },
          (listContents) => resolve(listContents),
          (error) => reject(error)
        )
      })
    }

    async _getShopifyProductsData(products) {
      if (!products.length) return []
      let buggedProductsArray = []
      let res = await Promise.all(
        products.map(async (pdp) => {
          try {
            const productHandleString = pdp.du.split('/products/')[1]
            const productHandle = productHandleString.split('?')[0]
            const reqURL = `/products/${productHandle}`
            const productData = await fetch(`${reqURL}.js`)
            const jsonData = await productData.json()
            pdp.productData = jsonData
            return pdp
          } catch (error) {
            const errorObj = {}
            errorObj[pdp.du] = error
            buggedProductsArray.push(errorObj)
            return null
          }
        })
      )

      console.log('Products with bugs - ', buggedProductsArray)
      res = res.filter((product) => product && product.productData)
      return res
    }

    _setListProperties(list, listContents, allProductsLoaded = false) {
      list.listcontents = listContents
      list.totalProducts = listContents.length
      list.allProductsLoaded = allProductsLoaded
      return list
    }

    async _addProductToList(product, lid, listType) {
      const onSuccessWishlist = async () => {
        this._hideContainer(this.wishlistContainer)
        this._showContainer(this.pageLoader)
        this.isSingleList
          ? this._renderSingleList(true)
          : this._renderMultipleList()
      }
      const onSuccessSFL = async () => {
        if (this.sflList && this.sflList.listcontents) {
          const sflProducts = await this._getSflProducts()
          this.sflList.listcontents =
            await this._getShopifyProductsData(sflProducts)
          this._renderProductsGrid(this.sflList.listcontents, 'sfl')
          this._switchGrid('sfl')
        }
      }

      const onError = (error) =>
        console.log('Error while adding the Product', error)
      if (listType == 'wishlist')
        this.swat.addToList(lid, product, onSuccessWishlist, onError)
      else if (listType == 'sfl')
        this.swat.SaveForLater.add(lid, [product], onSuccessSFL, onError)
    }

    async _deleteProductFromList(
      product,
      lid,
      listType,
      shouldSkipUIUpdate = false
    ) {
      const onSuccessWishlist = async (deletedProduct) => {
        if (this.isSingleList) {
          this.list.listcontents = this.list.listcontents.filter(
            (product) => product.epi !== deletedProduct.epi
          )
          this.list = this._setListProperties(
            this.list,
            this.list.listcontents,
            true
          )
          if (!shouldSkipUIUpdate) await this._renderSingleListHeader(lid)
        } else {
          this.lists = this.lists.map((list) => {
            if (list.lid === lid) {
              const updatedListContents = list.listcontents.filter(
                (product) => product.epi !== deletedProduct.epi
              )
              return this._setListProperties(
                { ...list },
                updatedListContents,
                true
              )
            }
            return list
          })
          if (!shouldSkipUIUpdate) this._renderListHeader(lid)
        }
      }

      const onError = (error) =>
        console.log('Error while deleting the Product', error)
      if (listType == 'wishlist')
        this.swat.deleteFromList(lid, product, onSuccessWishlist, onError)
    }

    async _deleteProductAndProductCardFromList(
      product,
      lid,
      parentNode,
      listType,
      shouldSkipUIUpdate = false
    ) {
      const onSuccessWishlist = async (deletedProduct) => {
        parentNode.remove()
        if (!this.productsContainer.querySelector('.swymcs-product-card')) {
          this._renderProductsGrid([])
        }
        if (this.isSingleList) {
          this.list.listcontents = this.list.listcontents.filter(
            (product) => product.epi !== deletedProduct.epi
          )
          this.list = this._setListProperties(
            this.list,
            this.list.listcontents,
            true
          )
          if (!shouldSkipUIUpdate) await this._renderSingleListHeader(lid)
        } else {
          this.lists = this.lists.map((list) => {
            if (list.lid === lid) {
              const updatedListContents = list.listcontents.filter(
                (product) => product.epi !== deletedProduct.epi
              )
              return this._setListProperties(
                { ...list },
                updatedListContents,
                true
              )
            }
            return list
          })
          if (!shouldSkipUIUpdate) this._renderListHeader(lid)
        }
      }

      const onSuccessSFL = async () => {
        parentNode.remove()
        if (!this.sflProductsContainer.querySelector('.swymcs-product-card')) {
          this._renderProductsGrid([], 'sfl')
        }
        this._renderSFLContainer()
      }
      const onError = (error) =>
        console.log('Error while deleting the Product', error)
      if (listType == 'wishlist')
        this.swat.deleteFromList(lid, product, onSuccessWishlist, onError)
      else if (listType == 'sfl')
        this.swat.SaveForLater.remove(lid, [product], onSuccessSFL, onError)
    }

    _renameList() {
      const listName = this.renameListTextField.value
      const isValidListName = this._validateListName(
        listName.trim().toLowerCase(),
        this.renameListError
      )
      if (!isValidListName) return
      const listUpdateConfig = {
        lid: window.currentActiveListId,
        lname: listName,
      }
      const onSuccess = async (updatedListObj) => {
        this._closeAdditionalOptionsPopup()
        const listcontents = this.lists.find(
          (list) => list.lid === updatedListObj.lid
        ).listcontents
        this.lists = this.lists.map((list) =>
          list.lid === updatedListObj.lid
            ? this._setListProperties(updatedListObj, listcontents, true)
            : list
        )
        this._renderListHeader(window.currentActiveListId)
      }
      const onError = (error) =>
        console.log(
          `Error while Renaming the List, ${window.currentActiveListId}`,
          error
        )
      window._swat.updateList(listUpdateConfig, onSuccess, onError)
    }

    _duplicateList() {
      const listName = this.duplicateListTextField.value
      const isValidListName = this._validateListName(
        listName.trim().toLowerCase(),
        this.duplicateListError
      )
      if (!isValidListName) return
      const listConfig = {
        lname: listName,
        fromlid: window.currentActiveListId,
      }
      const onSuccess = async (listObj) => {
        const listContents = this.lists.find(
          (list) => list.lid === window.currentActiveListId
        ).listcontents
        this.lists.unshift(this._setListProperties(listObj, listContents, true))
        this._hideContainer(this.listProductsContainer)
        this._renderListProducts(listObj.lid)
        this._closeAdditionalOptionsPopup()
      }
      const onError = (error) =>
        console.log(
          `Error while duplicating the List, ${window.currentActiveListId}`,
          error
        )
      window._swat.createList(listConfig, onSuccess, onError)
    }

    _deleteList() {
      const onSuccess = () => {
        this._closeAdditionalOptionsPopup()
        this.lists = this.lists.filter(
          (list) => list.lid != window.currentActiveListId
        )
        this._hideContainer(this.listProductsContainer)
        this._showContainer(this.pageLoader)
        if (this.isSingleList) {
          this.list = null
        }
        this.isSingleList
          ? this._renderSingleList()
          : this._renderMultipleList()
      }
      const onError = (error) =>
        console.log(
          `Error while deleting the List, ${window.currentActiveListId}`,
          error
        )
      window._swat.deleteList(window.currentActiveListId, onSuccess, onError)
    }

    _validateListName(name, errorField) {
      const isValidList = false
      if (name.length < 3) {
        errorField.textContent = 'Name must be longer than 3 characters'
        return isValidList
      }
      const lists = this.lists
      const matchedList = lists.find(
        (list) => list.lname.trim().toLowerCase() == name
      )
      if (matchedList) {
        errorField.textContent = 'List name already exists'
        return isValidList
      }
      errorField.textContent = ''
      return !isValidList
    }

    _validateEmail() {
      const emailPattern = /^\w+([.-]\w+)*@\w+([.-]\w+)*(\.\w{2,4})+$/
      const isBlank = this.shareEmailField.value == '' ? true : false
      const isInvalidString = !this.shareEmailField.value.match(emailPattern)
        ? true
        : false
      if (isBlank || isInvalidString) {
        this.shareListError.textContent = isBlank
          ? 'Please enter the email address'
          : 'Please enter a valid email address'
        return false
      }
      this.shareListError.textContent = ''
      return true
    }

    _openSelectionPopup(button) {
      this.currentModalContext = {
        lid: button.dataset.lid,
        listType: button.dataset.listType,
        productId: button.dataset.productId,
        originalVariantId: button.dataset.variantId,
        updatedVariantId: button.dataset.variantId,
        productUrl: button.dataset.du,
        productCard: button.closest('.swymcs-product-card'),
      }

      this.variantSelectionPopupTitle.textContent = button.dataset.title
      this.variantSelectionPopupContentBody.innerHTML = button
        .closest('.swymcs-product-card')
        .querySelector('.swymcs-variant-selector').innerHTML
      this.variantSelectionPopupContentBody.classList.remove(
        'swym-hide-container'
      )

      this.variantSelectionPopup.showModal()
    }

    _addProductToCart(button) {
      const epi = +button.dataset.epi
      const empi = +button.dataset.empi
      const du = button.dataset.du

      if (button.dataset.type == 'sfl' && !this.isShareWishlistPage) {
        this.sflList.listcontents = this.sflList.listcontents.filter(
          (product) => product.epi != epi
        )
        this._deleteProductAndProductCardFromList(
          {
            epi: epi,
            empi: empi,
            du: du,
          },
          window.saveForLaterListId,
          button.closest('.swymcs-product-card'),
          'sfl'
        )
      }
      this.swat.replayAddToCart(
        {
          empi,
          du,
          qty: 1,
        },
        epi,
        async (c) => {
          let updatedCart = JSON.parse(c)
          let line_item_key = updatedCart.items.find(
            (item) => item.id == epi
          ).key
          let updatedQty = updatedCart.items.find(
            (item) => item.id == epi
          ).quantity
          let cartTotal = document.querySelector('cart-total')
          cartTotal?.updateQuantityToCart({
            [line_item_key]: updatedQty,
          })
          cartTotal?.openCartDrawer()
          button.classList.add('swymcs-product-in-cart')
          button.textContent = 'Added to cart'
        },
        (error) => {
          button.textContent = 'Add to cart'
          window._swat.ui.uiRef.showErrorNotification({
            message: error.description,
          })
        }
      )
    }

    async _addAllProductToCart(evt) {
      try {
        const productsData = [
          ...this.querySelectorAll(
            '.swymcs-product-card .swymcs-add-to-cart-btn:not(:disabled)'
          ),
        ].map((container) => ({
          id: +container.dataset.epi,
          quantity: 1,
        }))
        let formData = { items: productsData }

        const response = await fetch(
          window.Shopify.routes.root + 'cart/add.js',
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData),
          }
        )

        const cartResponse = await response.json()
        cartResponse.items.forEach((item) => {
          const variantId = item.id
          const button = this.querySelector(
            `.swymcs-add-to-cart-btn[data-epi="${variantId}"]`
          )
          button.textContent = 'Added to cart'
        })
        evt.target.textContent = 'Added to cart'
        let cartTotal = document.querySelector('cart-total')
        cartTotal?.updateQuantityToCart()
        cartTotal?.openCartDrawer()
        this.swat.initializeActionButtons('form#cart')
      } catch (error) {
        window._swat.ui.uiRef.showErrorNotification({
          message: error.description,
        })
        console.error('Error:', error)
      }
    }

    _prepareShareLink(listId) {
      return new Promise((resolve, reject) => {
        this.swat.generateSharedListURL(
          listId,
          (link, lid) => resolve(link, lid),
          (err) => reject(err)
        )
      })
    }

    _shareListByCopy() {
      navigator.clipboard
        .writeText(this.shareLinkField.textContent)
        .then(() =>
          window._swat.ui.uiRef.showSuccessNotification({
            message: 'Link Copied to Clipboard!',
          })
        )
        .catch((error) =>
          window._swat.ui.uiRef.showErrorNotification({
            message: error.description,
          })
        )
    }

    _shareListByEmail() {
      const email = this._validateEmail()
      if (!email) return
      const onSuccess = () => {
        window._swat.ui.uiRef.showSuccessNotification({
          message: 'List shared successfully over mail',
        })
        this._closeAdditionalOptionsPopup()
      }
      const onError = (error) =>
        window._swat.ui.uiRef.showErrorNotification({
          message: error.description,
        })
      window._swat.sendListViaEmail(
        {
          toEmailId: this.shareEmailField.value.trim(),
          note: this.shareMessageField.value,
          fromName: this.shareNameField.value,
          lid: window.currentActiveListId,
        },
        onSuccess,
        onError
      )
    }

    _shareListOnPlatform(platform) {
      const shareUrl = this.shareLinkField.textContent
      const note = this.shareMessageField.value
      const fromName = this.shareNameField.value
      const onError = (error) =>
        window._swat.ui.uiRef.showErrorNotification({
          message: error.description,
        })
      let platformShareUrlTemplate = ''
      if (platform == 'facebook')
        platformShareUrlTemplate = `https://www.facebook.com/sharer.php?u=${shareUrl}&t=${note}`
      else if (platform == 'twitter')
        platformShareUrlTemplate = `https://twitter.com/share?text=${note}&url=${shareUrl}`
      window._swat.shareListSocial(
        window.currentActiveListId,
        fromName,
        platformShareUrlTemplate,
        platform,
        note,
        onError
      )
    }

    async _renderSFLContents() {
      if (!this.isSFLEnabled || this.isShareWishlistPage) return
      this.sflList = await this._getSflList()
      window.saveForLaterListId = this.sflList.listid
      const sflProducts = await this._getSflProducts()
      this.sflList.listcontents =
        await this._getShopifyProductsData(sflProducts)
      this._showContainer(this.pageTitleSFLTab)
      this._renderProductsGrid(this.sflList.listcontents, 'sfl')
      this._hideContainer(this.sflProductsContainer)
    }

    _getSflList() {
      return new Promise((resolve, reject) => {
        this.swat.SaveForLater.init(
          (list) => resolve(list),
          (error) => reject(error)
        )
      })
    }

    async _getSflProducts() {
      return new Promise((resolve, reject) => {
        this.swat.SaveForLater.fetch(
          window.saveForLaterListId,
          (products) => resolve(products.items),
          (error) => reject(error)
        )
      })
    }

    async _renderSFLContainer() {
      this._hideContainer(this.listsContainer)
      this._hideContainer(this.backToListView)
      this._hideContainer(this.emptyListContainer)
      this._hideContainer(this.emptySFLListContainer)
      this._showContainer(this.wishlistContainer)
      this._showContainer(this.listProductsContainer)
      this._hideContainer(this.productsContainer)
      this._showContainer(this.sflProductsContainer)

      const hasSFLData = this.sflList && this.sflList.listcontents != []
      if (!hasSFLData) {
        this._renderProductsGrid(this.sflList.listcontents, 'sfl')
      }
      this._switchGrid('sfl')
    }

    /* Header functions */

    _loginButtonAction(evt) {
      const redirectionUrl = evt.currentTarget.getAttribute(
        'data-redirection-url'
      )
      const actionUrl = evt.currentTarget.getAttribute('data-action-url')
      localStorage.setItem('SWYM_REDIRECT_URL', redirectionUrl)
      localStorage.setItem('SWYM_ACTION_URL', actionUrl)
      location.href = actionUrl
    }

    async _switchListsFromHeader(evt) {
      const page = document.querySelector('swym-wishlist-page')
      const lid = evt.target.dataset.lid
      page._hideContainer(page.listProductsContainer)
      page._renderListHeader(window.currentActiveListId)
      page._renderListProducts(lid)
      page._hidePopupContainer(page.headerListsContainer)
    }

    _toggleListView(evt) {
      if (!this.isSFLEnabled || this.isShareWishlistPage) return
      const target = evt.target
      if (
        target.classList.contains('swymcs-active-tab') ||
        !target.classList.contains('swymcs-page-title')
      )
        return

      let tabToDeselect =
        this.pageTitleTabContainer.querySelector('.swymcs-active-tab')
      let tabToSelect = this.pageTitleTabContainer.querySelector(
        '.swymcs-page-title:not(.swymcs-active-tab)'
      )
      tabToDeselect.classList.remove(
        'swymcs-active-tab',
        'text-t-white',
        'bg-t-black'
      )
      tabToDeselect.classList.add('text-t-black', 'bg-t-grey-light')
      tabToSelect.classList.add(
        'swymcs-active-tab',
        'text-t-white',
        'bg-t-black'
      )
      tabToSelect.classList.remove('text-t-black', 'bg-t-grey-light')
      if (target.dataset.type == 'wishlist') {
        let hasWishlistData = false
        if (this.isSingleList) {
          hasWishlistData = this.list && this.list.listcontents != []
        } else {
          hasWishlistData =
            window.currentActiveListId && this.lists && this.lists.length > 0
          if (hasWishlistData) {
            const activeList = this.lists.find(
              (list) => list.lid === window.currentActiveListId
            )
            hasWishlistData =
              activeList && activeList.listcontents !== undefined
          }
        }

        if (!hasWishlistData) {
          this.isSingleList
            ? this._renderSingleList(false)
            : this._renderMultipleList()
        } else {
          this._switchGrid('wishlist')
        }
      } else if (target.dataset.type == 'sfl') {
        this._renderSFLContainer()
      }
    }

    /* Product Grid Events */

    async _eventsForProductsGrid(evt) {
      const target = evt.target
      const page = document.querySelector('swym-wishlist-page')
      const purpose = target.dataset?.purpose
      if (!purpose) return
      evt.preventDefault()
      if (purpose == 'cart') page._addProductToCart(target)
      else if (purpose == 'select') page._selectProductSize(target)
      else if (purpose == 'open-selection-popup')
        page._openSelectionPopup(target)
      else if (purpose == 'delete') {
        page._deleteProductAndProductCardFromList(
          {
            epi: target.dataset.variantId,
            empi: target.dataset.productId,
            du: target.dataset.productUrl,
          },
          target.dataset.lid,
          target.closest('.swymcs-product-card'),
          target.dataset.listType
        )
      }
    }

    _eventsForVariantSelectionModal(evt) {
      const target = evt.target
      const purpose = target.dataset?.purpose
      if (!purpose) return
      else if (purpose == 'select') this._selectProductSizeInModal(target)
      else if (purpose == 'save-selection')
        this._saveSizeSelectionInProductCard(target)
    }

    _selectProductSizeInModal(sizeButton) {
      const selectedVariantClass = 'swym-selected-variant'
      if (sizeButton.classList.contains(selectedVariantClass)) return

      const parentNode = sizeButton.closest(
        '#swymcs-variant-selection-popup-content'
      )
      parentNode
        .querySelector(`.${selectedVariantClass}.swymcs-variant-selector-btn`)
        .classList.remove(selectedVariantClass)
      sizeButton.classList.add(selectedVariantClass)

      this.currentModalContext.updatedVariantId = sizeButton.dataset.variantId
    }

    async _saveSizeSelectionInProductCard() {
      const lid = this.currentModalContext.lid
      const listType = this.currentModalContext.listType
      const productCard = this.currentModalContext.productCard
      const productUrl = this.currentModalContext.productUrl
      const originalVariantId = +this.currentModalContext.originalVariantId
      const updatedVariantId = +this.currentModalContext.updatedVariantId
      const productId = +this.currentModalContext.productId

      if (originalVariantId != updatedVariantId) {
        await this._addProductToList(
          {
            epi: updatedVariantId,
            empi: productId,
            du: productUrl,
            cprops: {
              isSizeSelected: true,
            },
          },
          lid,
          listType,
          true
        )
        await this._deleteProductFromList(
          {
            epi: originalVariantId,
            empi: productId,
            du: productUrl,
          },
          lid,
          listType,
          true
        )
      } else {
        await this._addProductToList(
          {
            epi: updatedVariantId,
            empi: productId,
            du: productUrl,
            cprops: {
              isSizeSelected: true,
            },
          },
          lid,
          listType,
          true
        )
      }

      this.variantSelectionPopup.close()
      const sizeButton = productCard.querySelector(
        `.swymcs-variant-selector-btn[data-variant-id='${updatedVariantId}']`
      )
      this._selectProductSize(sizeButton)
    }

    _selectProductSize(sizeButton) {
      const selectedVariantClass = 'swym-selected-variant'
      const parentNode = sizeButton.closest('.swymcs-product-card')

      parentNode
        .querySelector(`.${selectedVariantClass}.swymcs-variant-selector-btn`)
        .classList.remove(selectedVariantClass)
      sizeButton.classList.add(selectedVariantClass)

      const addToCartButton = parentNode.querySelector(
        '.swymcs-add-to-cart-btn[data-purpose="cart"]'
      )
      const selectSizeButton = parentNode.querySelector(
        '.swymcs-add-to-cart-btn[data-purpose="open-selection-popup"]'
      )
      const variantTitle = parentNode.querySelector('.swymcs-selected-variant')
      const variantTitleText = parentNode.querySelector(
        '.swymcs-selected-variant span'
      )
      const isVariantAvailable = sizeButton.dataset.available == 'true'
      const variantId = sizeButton.dataset.variantId
      const variantCost = sizeButton.dataset.variantCost
      const priceContainer = parentNode.querySelector(
        '.price-item.price-item--regular'
      )

      isVariantAvailable
        ? addToCartButton.removeAttribute('disabled')
        : addToCartButton.setAttribute('disabled', '')
      addToCartButton.classList.toggle('swymcs-sold-out', !isVariantAvailable)
      let addToCartBtnText = this.settings.sold_out_text
      variantTitleText.textContent = 'Size: ' + sizeButton.textContent
      this._showContainer(variantTitle)
      if (isVariantAvailable) {
        addToCartBtnText = this.swat.platform.isInDeviceCart(variantId)
          ? `${this.settings.added_to_cart_text}`
          : `${this.settings.add_to_cart_text}`
      }
      addToCartButton.setAttribute('data-epi', variantId)
      addToCartButton.setAttribute('data-variant-cost', variantCost)
      addToCartButton.textContent = addToCartBtnText
      priceContainer.textContent = `${window.currencyCode}${variantCost}`
      selectSizeButton.classList.toggle('swym-hide-container')
      addToCartButton.classList.toggle('swym-hide-container')
    }

    /* Additional Options */
  }
  customElements.define('swym-wishlist-page', SwymWishlistPage)
}
